export enum TestId {
    ActionAddToFavorites = 'action-add-to-favorites',
    ActionCallMeetingId = 'action-call-meeting-id',
    ActionDeleteRecent = 'action-delete-recent',
    ActionRemoveFavorite = 'action-remove-favorite',
    ActionEnterDTMF = 'action-enter-dtmf',
    ActionFecc = 'action-fecc',
    ActionLowerHand = 'action-lower-hand',
    ActionMakeGuest = 'action-make-guest',
    ActionMakeHost = 'action-make-host',
    ActionMuteMicrophone = 'action-mute-microphone',
    ActionRemoveSpotlight = 'action-remove-spotlight',
    ActionSpotlight = 'action-spotlight',
    ActionTransfer = 'action-transfer',
    ActionUnmuteMicrophone = 'action-unmute-microphone',
    AudioMeterSettings = 'audio-meter-settings',
    BadgeCounterBreakoutRoomsPanelButton = 'badge-counter-breakout-rooms-panel-button',
    BadgeCounterParticipantPanelButton = 'badge-counter-participant-panel-button',
    BreakoutAssignAutoBtn = 'breakout-assign-auto-btn',
    BreakoutAssignManuallyBtn = 'breakout-assign-manually-btn',
    BreakoutAssignRoomMenu = 'breakout-assign-room-menu',
    BreakoutAssignRoomMenuButton = 'breakout-assign-room-menu-button',
    BreakoutNumberOfRoomsInput = 'roomsInput-number-step-input',
    BreakoutRoom = 'breakout-room',
    BreakoutRoomsPanelWrapper = 'breakout-rooms-panel-wrapper',
    BreakoutSetupPanelBackBtn = 'breakout-setup-panel-back-btn',
    ButtonAdmitParticipant = 'button-admit-participant',
    ButtonAudioMeter = 'button-audio-meter',
    ButtonAudioMeterMuted = 'button-audio-meter-muted',
    ButtonBackgroundEffectsOff = 'button-background-effects-off',
    ButtonBackgroundEffectsOn = 'button-background-effects-on',
    ButtonBackgroundEffectNone = 'button-background-effect-none',
    ButtonBackgroundEffectBlurLow = 'button-background-effect-blur-low',
    ButtonBackgroundEffectBlurHigh = 'button-background-effect-blur-high',
    ButtonBackgroundEffectUpload = 'button-background-effect-upload',
    ButtonBackgroundEffectImage = 'button-background-effect-image',
    ButtonBackgroundEffectRemoveImage = 'button-background-effect-remove-image',
    ButtonBackgroundEffectSave = 'button-background-effect-save',
    ButtonBackgroundEffectCancel = 'button-background-effect-cancel',
    ButtonBackgroundEffectNavigateLeft = 'button-background-effect-navigate-left',
    ButtonBackgroundEffectNavigateRight = 'button-background-effect-navigate-right',
    ButtonBreakoutJoinAskingForHelp = 'button-breakout-join-asking-for-help',
    ButtonBreakoutRoomAddRoom = 'button-breakout-rooms-add-room',
    ButtonBreakoutRoomEdit = 'button-breakout-rooms-edit',
    ButtonBreakoutRoomHeader = 'button-breakout-rooms-edit-header',
    ButtonBreakoutRoomSettings = 'breakout-rooms-settings',
    ButtonBreakoutRoomShuffle = 'button-breakout-rooms-shuffle',
    ButtonBreakoutRooms = 'button-breakout-rooms',
    ButtonBreakoutRoomsCancelGoBackToModeAssignment = 'button-breakout-rooms-cancel-go-back-to-mode-assignment',
    ButtonBreakoutRoomsCancelGoBackToOpenedRooms = 'button-breakout-rooms-cancel-go-back-to-opened-rooms',
    ButtonBreakoutRoomsConfiguration = 'button-breakout-rooms-configuration',
    ButtonBreakoutRoomsConfirmGoBackToModeAssignment = 'button-breakout-rooms-confirm-go-back-to-mode-assignment',
    ButtonBreakoutRoomsConfirmGoBackToOpenedRooms = 'button-breakout-rooms-confirm-go-back-to-opened-rooms',
    ButtonBreakoutRoomsNumberOfRoomDecrement = 'roomsInput-number-step-decrement',
    ButtonBreakoutRoomsNumberOfRoomIncrement = 'roomsInput-number-step-increment',
    ButtonCallControlsTouchMoreMenuBack = 'button-call-controls-touch-more-menu-back',
    ButtonCallHistoryDeleteAllRecents = 'button-call-history-delete-all-recents',
    ButtonCallHistoryDeleteAllFavorites = 'button-call-history-delete-all-favorites',
    ButtonCallHistoryItemMenu = 'button-call-history-item-menu',
    ButtonCallHistoryRecentsTab = 'button-call-history-recents-tab',
    ButtonCallHistoryFavoritesTab = 'button-call-history-favorites-tab',
    ButtonCallHistoryPanelClose = 'button-call-history-panel-close',
    ButtonChat = 'button-chat',
    ButtonChatDirectMessagePreview = 'button-chat-direct-message-preview',
    ButtonChatDirectTab = 'button-chat-direct-tab',
    ButtonChatEveryoneTab = 'button-chat-everyone-tab',
    ButtonChatNewDirectMessage = 'button-chat-new-direct-message',
    ButtonChatSend = 'button-chat-send',
    ButtonCloseInvitationModal = 'button-invitation-modal',
    ButtonCollapseSelfview = 'button-collapse-selfview',
    ButtonCopyMeetingLink = 'button-copy-meeting-link',
    ButtonDenyParticipant = 'button-deny-participant',
    ButtonDeviceSettings = 'button-device-settings',
    ButtonDismiss = 'button-dismiss',
    ButtonDragFoldedSelfview = 'button-drag-folded-selfview',
    ButtonDuplicateRoomName = 'button-duplicate-room-name',
    ButtonExpandSelfview = 'button-hide-selfview',
    ButtonFlipCamera = 'button-flip-camera',
    ButtonFlipCameraInMeetingSelfview = 'button-flip-camera-in-meeting-selfview',
    ButtonInviteMemberSearchRow = 'button-invite-member-search-row',
    ButtonJoinAudioOnly = 'button-join-audio-only',
    ButtonJoinMeeting = 'button-join-meeting',
    ButtonJoinMeetingWithOptions = 'button-join-meeting-with-options',
    ButtonJoinWithVideo = 'button-join-with-video',
    ButtonKickOffParticipant = 'button-kick-off-participant',
    ButtonLeave = 'button-leave',
    ButtonLowerHand = 'button-lower-hand',
    ButtonLowerHandParticipantRow = 'button-lower-hand-participant-row',
    ButtonMeetingAudioInput = 'button-meeting-audioinput',
    ButtonMeetingAudioInputMuted = 'button-meeting-audioinput-muted',
    ButtonMeetingBackgroundEffectsOff = 'button-meeting-background-effects-off',
    ButtonMeetingBackgroundEffectsOn = 'button-meeting-background-effects-on',
    ButtonMeetingVideoInput = 'button-meeting-videoinput',
    ButtonMeetingVideoInputMuted = 'button-meeting-videoinput-muted',
    ButtonMoveToBreakoutNow = 'button-move-to-breakout-room-now',
    ButtonMuteParticipant = 'button-mute-participant',
    ButtonParticipants = 'button-participants',
    ButtonPeerMuted = 'button-peer-muted',
    ButtonPeerMutedCamera = 'button-peer-muted-camera',
    ButtonPeerPresenting = 'button-peer-presenting',
    ButtonPeerUnmuteCamera = 'button-peer-unmute-camera',
    ButtonQuality = 'button-quality',
    ButtonRaiseHand = 'button-raise-hand',
    ButtonRemoveUserCancel = 'button-remove-user-cancel',
    ButtonRemoveUserConfirm = 'button-remove-user-confirm',
    ButtonRequestPermissions = 'button-request-permissions',
    ButtonRoomSettingsHoursInputDecrement = 'hoursInput-number-step-decrement',
    ButtonRoomSettingsHoursInputIncrement = 'hoursInput-number-step-increment',
    ButtonRoomSettingsMinutesInputDecrement = 'minutesInput-number-step-decrement',
    ButtonRoomSettingsMinutesInputIncrement = 'minutesInput-number-step-increment',
    ButtonSaveBreakoutRoomsEdit = 'button-save-breakout-rooms-edit',
    ButtonSelfviewQuality = 'button-selfview-quality',
    ButtonSettingsBack = 'button-settings-back',
    ButtonSettingsResetToMeetingLayout = 'button-settings-reset-to-meeting-layout',
    ButtonSettingsSaveAll = 'button-settings-save-all',
    ButtonSettingsSaveMyself = 'button-settings-save-myself',
    ButtonSuggestionItemFavoriteToggle = 'button-suggestion-item-favorite-toggle',
    ButtonStartPresentation = 'button-start-presentation',
    ButtonStealPresentationCancel = 'button-steal-presentation-cancel',
    ButtonStealPresentationConfirm = 'button-steal-presentation-confirm',
    ButtonStopPresentation = 'button-stop-presentation',
    ButtonTestAudioInputAgain = 'button-test-audio-input-again',
    ButtonTestAudioInputStart = 'button-test-audio-input-start',
    ButtonTestAudioInputTryAgain = 'button-test-audio-input-try-again',
    ButtonToggleAudioInFoldedSelfview = 'button-toggle-audio-in-folded-selfview',
    ButtonToggleVideoInFoldedSelfview = 'button-toggle-video-in-folded-selfview',
    ButtonToolbarMoreItems = 'button-toolbar-more-items',
    ButtonTryAgain = 'button-try-again',
    ButtonVideoInput = 'button-videoinput',
    ButtonVideoinputMuted = 'button-videoinput-muted',
    CancelBreakoutSettings = 'cancel-breakout-settings',
    CallHistoryItem = 'call-history-item',
    CallHistoryItemExpiredTag = 'call-history-item-expired-tag',
    ChatActivityMessage = 'chat-activity-message',
    ChatActivityMessageDisplayName = 'chat-activity-message-display-name',
    ChatActivityMessageText = 'chat-activity-message-text',
    ChatEmptyActivityMessage = 'chat-empty-activity-message',
    ChatForm = 'chat-form',
    ChatInput = 'chat-input',
    ChatMessage = 'chat-message',
    ChatMessageLink = 'chat-message-link',
    ChatMessageName = 'chat-message-name',
    ChatMessageNameMeta = 'chat-message-name-meta',
    ChatMessageText = 'chat-message-text',
    ChatMessages = 'chat-messages',
    ChatPanel = 'chat-panel',
    ChatPanelContent = 'chat-panel-content',
    ChatRemoveActivityMessage = 'chat-remove-activity-message',
    ChatUnreadEveryoneMessagesIndicator = 'chat-unread-everyone-messages-indicator',
    ChatUnreadMessageIndicator = 'chat-unread-message-indicator',
    ChatUnseenDirectMessagesIndicator = 'chat-unseen-direct-messages-indicator',
    CheckEverythingWorksText = 'check-that-everything-works',
    CloseBreakoutRoom = 'close-breakout-room',
    CloseBreakoutRooms = 'close-breakout-rooms',
    CloseBreakoutRoomsModalCancel = 'close-breakout-rooms-modal-cancel',
    CloseBreakoutRoomsModalConfirm = 'close-breakout-rooms-modal-confirm',
    ConfirmationModalCancelButton = 'confirmation-modal-cancel-button',
    ConfirmationModalConfirmButton = 'confirmation-modal-confirm-button',
    DevicesSelection = 'devices-selection',
    DevicesSelectionBlocked = 'devices-selection-blocked',
    FoldedSelfview = 'folded-selfview',
    GoToBreakoutSetupPanel = 'go-to-breakout-setup-panel',
    HeaderLogo = 'header-logo',
    HeaderSubTitle = 'header-subtitle',
    HeaderTitle = 'header-title',
    IconCameraMuted = 'icon-camera-muted',
    IconMuted = 'icon-muted',
    IconMutedByAHost = 'icon-muted-by-a-host',
    IconPresenting = 'icon-presenting',
    IconSpotlight = 'icon-spotlight',
    InvitationSearchInput = 'invitation-search-input',
    JoinBreakoutRoom = 'join-breakout-room',
    JoinCallDetailsWrapper = 'join-call-details-wrapper',
    Layout = 'layout',
    LayoutLabel = 'layout-label',
    LinkMuteAllGuests = 'link-mute-all-guests',
    LinkOpenMeetingSettings = 'link-open-meeting-settings',
    LinkTestAudioInput = 'link-test-audio-input',
    LinkTestAudioOutput = 'link-test-audio-output',
    MeetingLinkText = 'meeting-link-text',
    MeetingLinkWrapper = 'meeting-link-wrapper',
    MeetingVideoFull = 'meeting-video-large',
    MeetingVideoPip = 'meeting-video-pip',
    MeetingWrapper = 'meeting-wrapper',
    MetricAudio = 'metric-audio',
    MetricAudioIn = 'metric-audio-in',
    MetricAudioOut = 'metric-audio-out',
    MetricPreso = 'metric-preso',
    MetricPresoIn = 'metric-preso-in',
    MetricPresoOut = 'metric-preso-out',
    MetricVideo = 'metric-video',
    MetricVideoIn = 'metric-video-in',
    MetricVideoOut = 'metric-video-out',
    MissingAudioDeviceAlert = 'missing-audio-device-alert',
    MissingVideoDeviceAlert = 'missing-video-device-alert',
    ModalBreakoutRoomsGoBackToModeAssignment = 'modal-breakout-rooms-go-back-to-mode-assignment',
    ModalBreakoutRoomsGoBackToOpenedRooms = 'modal-breakout-rooms-go-back-to-opened-rooms',
    ModalInvitation = 'modal-invitation',
    ModalLayoutChangeConfirmation = 'modal-layout-change-confirmation',
    ModalMoveToRoom = 'modal-move-to-breakout-room',
    ModalOpenRoomsError = 'modal-open-rooms-error',
    ModalRemoveUser = 'modal-remove-user',
    ModalRoomSettings = 'modal-room-settings',
    ModalStealPresentation = 'modal-steal-presentation',
    NetworkConnectedState = 'network-connected-state',
    NetworkReconnectedState = 'network-reconnected-state',
    NetworkReconnectingState = 'network-reconnecting-state',
    NotificationToolTipAudioCloseButton = 'notification-tooltip-audio-close-button',
    NotificationToolTipAudioProblem = 'notification-tooltip-audio-problem',
    NotificationToolTipDeviceError = 'notification-tooltip-device-error',
    NotificationToolTipVideoCloseButton = 'notification-tooltip-video-close-button',
    NotificationToolTipVideoProblem = 'notification-tooltip-video-problem',
    NotificationTooltipPreviouslyBlocked = 'notification-tooltip-previously-blocked',
    NotificationTooltipSelfviewHidden = 'notification-tooltip-selfview-hidden',
    OpenBreakoutRooms = 'open-breakout-rooms',
    PanelHeaderCloseButton = 'panel-header-close-button',
    PanelHeaderTitle = 'panel-header-title',
    ParticipantMenuButton = 'participant-menu-button',
    ParticipantPanel = 'participant-panel',
    ParticipantRow = 'participant-row',
    PermissionsRequestMessageWrapper = 'permissions-request-message-wrapper',
    PillNewChatMessage = 'new-chat-message-pill',
    PresentationFull = 'presentation-large',
    PresentationPip = 'presentation-pip',
    RemoveBreakoutRoom = 'remove-breakout-room',
    RoomSettingsHoursInput = 'hoursInput-number-step-input',
    RoomSettingsMinutesInput = 'minutesInput-number-step-input',
    SaveBreakoutSettings = 'save-breakout-settings',
    SearchRow = 'search-row',
    SelectAudioInput = 'select-audio-input',
    SelectAudioInputErrorText = 'select-audio-input-error-text',
    SelectAudioOutput = 'select-audio-output',
    SelectTestAudioInput = 'select-test-audio-input',
    SelectTestAudioInputPlayback = 'select-test-audio-input-playback',
    SelectTestAudioInputSpeakerPlayback = 'select-test-audio-input-speaker-playback',
    SelectVideoInput = 'select-video-input',
    SelectVideoInputErrorText = 'select-video-input-error-text',
    SendInviteLink = 'send-invite-link',
    SettingButtonRequestPreview = 'setting-button-request-preview',
    SettingButtonTryAgain = 'setting-button-try-again',
    SettingIconCameraOff = 'setting-icon-camera-off',
    SettingIconWarning = 'setting-icon-warning',
    SettingsVideoSelfview = 'settings-video-selfview',
    SettingsVideoSelfviewPreviewLabel = 'settings-video-selfview-preview-label',
    SettingsVideoSelfviewWrapper = 'settings-video-selfview-wrapper',
    SpeakingIndicator = 'speaking-indicator',
    StatsModal = 'stats-modal',
    SuggestionItem = 'suggestion-item',
    TestAudioInputIndicator = 'test-audio-input-indicator',
    TextLinkLearnDismissRequestPermissions = 'text-link-dismiss-learn-request-permissions',
    TextLinkLearnRequestPermissions = 'text-link-learn-request-permissions',
    TextLinkTryAgainRequestPermissions = 'text-link-try-again-request-permissions',
    TextLinkUnblockPermissionsVideo = 'text-link-unblock-permissions-video',
    TextNoStatsAvailable = 'text-no-stats-available',
    ToastYouAreTemporarilyUnmuted = 'toast-you-are-temporarily-unmuted',
    ToggleFecc = 'toggle-fecc',
    ToggleNoiseSuppression = 'toggle-noise-suppression',
    TogglePreferPresInMix = 'toggle-prefer-in-mix',
    TogglePrioritizeSharingMotion = 'toggle-prioritize-sharing-motion',
    TooltipDeniedDevice = 'tooltip-denied-device',
    TooltipMuteDisabled = 'tooltip-mute-disabled',
    UserMenuAddParticipant = 'user-menu-add-participant',
    VideoMeeting = 'video-meeting',
    VideoPresentation = 'video-presentation',
    VideoSelfview = 'video-selfview',
    VideoSelfviewWrapper = 'video-selfview-wrapper',
    VideoSplashText = 'video-splash-text',
    VideoStatus = 'video-status',
    VideoStatusBody = 'video-status-body',
    VideoStatusTitle = 'video-status-title',
}
